export default __webpack_public_path__ + "static/media/up.a4d6e955.png";